import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import flexOptions, { flexAutoSizingComponentVariant } from '../../../common/flex-options/flex-options.esm.js';

var cardBodyWrapperTV = getTvObject({
  base: flexOptions.base,
  variants: _objectSpread2(_objectSpread2({}, flexOptions.variants), {}, {
    scrollable: {
      "true": 'overflow-y-auto'
    }
  }),
  compoundVariants: flexAutoSizingComponentVariant
});
var base = tv(cardBodyWrapperTV);
var cardBodyWrapperStyles = {
  base: base
};

export { cardBodyWrapperStyles, cardBodyWrapperTV };
//# sourceMappingURL=card-body-wrapper.styles.esm.js.map
